import lightTheme from '../components/style/lightTheme';

const typography = {
  fontFamily: ['Noto Sans'].join(','),
  fontWeightBold: 600,
  h1: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Light',
    lineHeight: '3rem',
    fontSize: '2.5rem',
    letterSpacing: 0,
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  h1Bold: {
    fontFamily: 'Noto Sans',
    fontWeight: 700,
    lineHeight: '48px',
    fontSize: '40px',
    paragraphSpacing: '24px',
    letterSpacing: '0px',
  },
  h2: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Light',
    lineHeight: '44px',
    fontSize: '32px',
    paragraphSpacing: '16px',
    letterSpacing: '0px',
  },
  h3: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '32px',
    fontSize: '24px',
    paragraphSpacing: '12px',
    letterSpacing: '0px',
  },
  h4: {
    fontFamily: 'Noto Sans',
    fontWeight: 500,
    lineHeight: '32px',
    fontSize: '20px',
    paragraphSpacing: '12px',
    letterSpacing: '0.15px',
  },
  h5: {
    color: '#000',
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    lineHeight: '2.4rem',
    fontSize: '1.5rem',
    letterSpacing: '0px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  h6: {
    fontFamily: 'Noto Sans',
    lineHeight: '2rem',
    fontSize: '1.25rem',
    letterSpacing: '0.15px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    fontWeight: 500,
    textCase: 'none',
    textDecoration: 'none',
  },
  body1: {
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    lineHeight: '24px',
    fontSize: '16px',
    paragraphSpacing: '12px',
    letterSpacing: '0.12px',
  },
  body1Bold: {
    fontFamily: 'Noto Sans',
    fontSize: '1rem',
    fontWeight: 700,
  },
  body2: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '1.43rem',
    fontSize: '0.875rem',
    letterSpacing: 0.17,
    paragraphSpacing: '0.75rem',
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  body2Bold: {
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    textAlign: 'left',
    color: lightTheme.text,
  },
  subtitle1: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '1.75rem',
    fontSize: '1rem',
    letterSpacing: 0.15,
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  subtitle2: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '1.57rem',
    fontSize: '0.875rem',
    letterSpacing: 0.1,
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  overline: {
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    lineHeight: '32px',
    fontSize: '12px',
    letterSpacing: '2px',
    textDecoration: 'none',
  },
  caption: {
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    lineHeight: '20px',
    fontSize: '12px',
    letterSpacing: '0.4px',
  },
  chipLabel: {
    fontFamily: 'Noto Sans',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '1.5px',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  helperText: {
    fontFamily: 'Noto Sans',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '166%',
    letterSpacing: '0.4px',
    color: lightTheme.textSecondary,
  },
  label: {
    fontFamily: 'Noto Sans',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '166%',
    letterSpacing: '0.4px',
    color: lightTheme.text,
  },
} as const;

export default typography;
